/* eslint-disable no-console */
import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { useIdleTimer } from 'react-idle-timer';

import 'assets/vendors/style';
import 'styles/main.less';
import store, { history } from './redux/store';
import App from './containers/App/index';
import encryptStorage from './util/encryption';

const NextApp = () => {
  const handleOnIdle = () => {
    encryptStorage.clear();
    if (history.location.path !== '/signin') {
      window.location.href = '/app/signin';
    }
  };

  // Logs out user after 5 minutes inactivity
  useIdleTimer({
    timeout: 1000 * 60 * (process.env.REACT_APP_IDLE_TIME || 5),
    onIdle: handleOnIdle,
    debounce: 500,
  });

  return (
    <Provider store={store}>
      <BrowserRouter basename="/app" history={history}>
        <Switch>
          <Route path="/" component={App} />
        </Switch>
      </BrowserRouter>
    </Provider>
  );
};

export default Sentry.withProfiler(NextApp);
